import React from "react";
import Layout from "Layout";
import { API_URL } from "env";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Spin } from "antd";
import { useLocation } from "react-router-dom";
import ThirteenWeeksContent from "./ThirteenWeeks";
import use13WAccess from "hooks/use13WAccess";

const Academy: React.FC = () => {
  const purchased = use13WAccess();
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;
  const location = useLocation();

  const tab = new URLSearchParams(location.search).get("tab");

  const [haveContent, setHaveContent] = React.useState<boolean>(false);
  const [title, setTitle] = React.useState<string>(
    "This is Test Content for Academy Page "
  );
  const [subtitle, setSubtitle] = React.useState<string>("");
  const [content, setContent] = React.useState<any>(null);

  async function fetchData() {
    try {
      setHaveContent(false);
      const response = await fetch(
        `${API_URL}/api/v1/be/events?type=challenge`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        const items = data.data.items[0];
        const titleData = items.title;
        const subtitleData = items.subtitle;
        const dataContent = JSON.parse(items.description || "[]");
        if (currentLanguage === "en") {
          setTitle(titleData.en || "No Title");
          setSubtitle(subtitleData.en || "No Subtitle");
          setContent(dataContent.en);
        } else {
          setTitle(titleData.vi || "No Title");
          setSubtitle(subtitleData.vi || "No Subtitle");
          setContent(dataContent.vi);
        }
        setHaveContent(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  React.useEffect(() => {
    if (!tab) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLanguage, tab]);

  return (
    <Layout contentClassName="page--tight">
      <Helmet>
        <title>My 13w Trade Account - Lumir</title>
      </Helmet>
      {purchased === null ? (
        <div className="flex items-center justify-center min-h-[90vh]">
          <Spin size="large" />
        </div>
      ) : purchased ? (
        <ThirteenWeeksContent />
      ) : haveContent ? (
        <div className="flex flex-col gap-4 p-4  items-center academy-container min-h-[90vh] rounded-[6px]">
          {content ? (
            <>
              <div className="academy-content-text" dangerouslySetInnerHTML={{ __html: content }} />
              <div className="flex flex-row justify-center gap-4 mt-4">
                <div>
                  <a href="/profile/account">{t('haveNFTNoteAcademy')}</a>
                </div>
                <div className="">
                  <a href="https://wealthfarming.app/">{t('buyNFTNoteAcademy')}</a>
                </div>
              </div>
            </>
          ) : (
            <p>Loading content...</p>
          )}
        </div>
      ) : (
        <>
          <div className=" text-gray-800 dark:text-gray-100 antialiased">
            <main className="container w-full mx-auto">
              <section className="mx-auto academy-container border border-gray-100 dark:border-gray-700 rounded-2xl shadow-lg p-10 flex flex-col items-center gap-8">
                {/* Illustration */}
                <div className="flex-shrink-0 w-full flex items-center justify-center">
                  <svg
                    className="w-64 h-64"
                    viewBox="0 0 200 200"
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-labelledby="emptyTitle"
                  >
                    <title id="emptyTitle">
                      {t('noeventTitle')}
                    </title>
                    <defs>
                      <linearGradient id="g1" x1="0" x2="1">
                        <stop offset="0%" stopColor="#60a5fa" />
                        <stop offset="100%" stopColor="#a78bfa" />
                      </linearGradient>
                    </defs>
                    <rect
                      x="10"
                      y="30"
                      width="180"
                      height="120"
                      rx="12"
                      fill="url(#g1)"
                      opacity="0.15"
                    />
                    <g transform="translate(40,46)">
                      <rect
                        x="0"
                        y="0"
                        width="120"
                        height="80"
                        rx="8"
                        fill="#fff"
                        opacity="0.9"
                        stroke="#e6e6e6"
                      />
                      <circle cx="20" cy="22" r="6" fill="#f87171" />
                      <rect
                        x="34"
                        y="16"
                        width="60"
                        height="6"
                        rx="3"
                        fill="#94a3b8"
                      />
                      <rect
                        x="6"
                        y="46"
                        width="108"
                        height="6"
                        rx="3"
                        fill="#c7d2fe"
                      />
                      <rect
                        x="6"
                        y="60"
                        width="108"
                        height="6"
                        rx="3"
                        fill="#c7d2fe"
                      />
                    </g>
                    <path
                      d="M40 160c12-18 30-28 60-28s48 10 60 28"
                      fill="none"
                      stroke="#a78bfa"
                      strokeWidth="4"
                      strokeLinecap="round"
                      opacity="0.6"
                    />
                  </svg>
                </div>

                {/* Text content */}
                <div className="w-full md:w-3/4 text-center md:text-left">
                  <h1 className="text-3xl font-semibold mb-3">
                    {t('noeventSubTitle')}
                  </h1>
                  <p className="text-gray-600 dark:text-gray-300 mb-6">
                    {t('noeventDesc')} <a href="https://beqholdings.com/news/" className="text-blue-600 underline">{t('noeventLink')}</a>
                  </p>

                  <div className="flex flex-col sm:flex-row items-center justify-center  gap-3">
                    <button
                      onClick={() => window.location.reload()}
                      className="px-5 py-2 rounded-lg border border-gray-200 dark:border-gray-700 dark:bg-gray-700 text-sm"
                    >
                      {t('noeventBtn')}
                    </button>
                  </div>

                  <div className="mt-6 text-sm text-gray-500 dark:text-gray-400">
                    <p>
                      {t('noeventnote')}
                    </p>
                  </div>
                </div>
              </section>
            </main>
          </div>
        </>
      )}
    </Layout>
  );
};
export default Academy;
